export const SPINNER_ICON_BORDER_SIZES_MAP_IN_REM = Object.freeze({
  default: 0.25,
  large: 0.3,
  medium: 0.25,
  small: 0.15,
});

export const SPINNER_ICON_SIZES_IN_REM = Object.freeze({
  default: 4,
  large: 6,
  medium: 4,
  small: 2,
});
